module.exports = __webpack_public_path__ + "static/media/kangyang-5@2x.29f523cf.png";